import {detailServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + '/organizations/modules'

export default class ModuleController {
    static async get() {
        return axios.get(restUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getById(id) {
        return axios.get(restUrl + "/" + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(data, id) {
        return await axios.put(restUrl + '/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data) {
        return await axios.post(restUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async addDepend(id,dependModuleId) {
        return await axios.patch(restUrl+ '/' + id+"/add-depend?dependModuleId="+dependModuleId,[], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id);
    }

}